import { render, staticRenderFns } from "./staking.vue?vue&type=template&id=cba78fc2&scoped=true&"
var script = {}
import style0 from "./staking.vue?vue&type=style&index=0&id=cba78fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba78fc2",
  null
  
)

export default component.exports